import { Specifications } from '../../types/listing/specifications';

export const standardSpecifications:Specifications = {
    contactBrokerForPrice: false,
    showPriceWithUoM: true,
    leaseTerm: "",
    leaseType: "",
    leaseRateType: "",
    maxPrice: 0,
    maxSpace: 0,
    salePrice: 0,
    totalSpace: 0,
    measure: "",
    minPrice: 0,
    minSpace: 0,
    includingSalesTax: false,
    plusSalesTax: false,
    currencyCode: "USD",
    spaceUnitOfMeasure: "sf"
}